import { InternalAxiosRequestConfig } from "axios";

export const requestAuthInterceptor = ( config: InternalAxiosRequestConfig ) => {

  const token = localStorage.getItem("token");

  if (token) {
    config.headers.set("Authorization", `Bearer ${token}`);
  }

  return config;
};
